class DomainMatchedThemeError extends Error {
    constructor(themeName, hostname, originalError) {
        const message = `Theme configuration file '${themeName}.json' required by domain '${hostname}' failed to load. Original error: ${originalError.message}`;
        super(message);
        this.name = 'DomainMatchedThemeError';
        this.themeName = themeName;
        this.hostname = hostname;
        this.originalError = originalError;
        this.isDomainMatched = true; // Flag for easy detection
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

module.exports = {
    DomainMatchedThemeError,
};
